/** Ruta del asistente de puesta en marcha. */
export const SETUP_PATH = '/puesta-en-marcha';
/** Lo único que tiene quien hace la puesta en marcha: el asistente y «Mi perfil» (con ingreso local, la verificación en dos pasos). */
const SETUP_PATHS = [SETUP_PATH, '/perfil'];

/**
 * Qué se muestra en `pathname` (como en SGDEA): en puesta en marcha (`me.operation === 'SETUP'`) primero se termina
 * eso. Quien la hace (`admin.advanced`) solo tiene el asistente, sin menú, y cualquier otra ruta, también escrita a
 * mano, vuelve a él; los demás ven solo que la organización se prepara. En operación el asistente ya no existe.
 */
export function setupGate(me: { operation?: string } | null, admin: boolean, pathname: string): 'app' | 'preparing' | { redirect: string } {
  const inSetup = pathname === SETUP_PATH || pathname.startsWith(`${SETUP_PATH}/`);
  if (me?.operation !== 'SETUP') return inSetup ? { redirect: '/' } : 'app';
  if (!admin) return 'preparing';
  return SETUP_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`)) ? 'app' : { redirect: SETUP_PATH };
}
